// extracted by mini-css-extract-plugin
export default {"radioitems":"style_radioitems__A9rmG","radio-circle":"style_radio-circle__fwfXi","label-text":"style_label-text__oCi29","radio-circle-inner":"style_radio-circle-inner__OfUxP"};